import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { InputAdornment, TextField } from '@mui/material';
import { selectFieldValueI18n } from '@icp/form-renderer-core';
import { composeEvent, composeEventAsync } from '@icp/utils';
import { useSelector } from '../../../store';
import { ValueLanguageSelectMaterial } from '../../../ValueLanguageSelect';
import InputClearButton from './InputClearButton';

function I18nInputSingle(props) {
  const {
    id,
    languageOp,
    value: valueProp,
    onChange,
    onBlur,
    onKeyDown,
    onKeyUp,
    readonly,
    allowClear,
    inputMode,
    onClear,
    ...other
    //
  } = props;

  const valueI18n = useSelector(selectFieldValueI18n(id, languageOp.value));
  const [value, setValue] = useState(valueI18n);
  // 让 keydown 和 keyup 之间 onChange 只会触发一次，防止一致按住 Enter 键反复触发 onChange
  const once = useRef(false);

  useEffect(() => {
    setValue(valueI18n);
  }, [valueI18n]);

  // 当 changeDelayToBlur 时，按回车键也需要触发 onChange。和原生 input 逻辑一致
  const handleKeyDown = (event) => {
    if (once.current) {
      return;
    }

    if (event.key === 'Enter') {
      once.current = true;
      onChange(value, languageOp.value);
    }
  };

  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      once.current = false;
    }
  };

  return (
    <TextField
      {...other}
      fullWidth={true}
      value={value ?? ''}
      onChange={(event) => setValue(event.target.value)}
      onBlur={composeEventAsync(() => onChange(value, languageOp.value), onBlur)}
      onKeyDown={composeEvent(handleKeyDown, onKeyDown)}
      onKeyUp={composeEvent(handleKeyUp, onKeyUp)}
      InputProps={{
        readOnly: readonly,
        startAdornment: (
          <InputAdornment position="start">
            <ValueLanguageSelectMaterial value={languageOp.value} readonly={true} />
          </InputAdornment>
        ),
        endAdornment:
          !readonly && valueI18n && allowClear ? <InputClearButton onClear={onClear} /> : null,
        inputProps: {
          inputMode,
          autoComplete: 'off',
        },
      }}
    />
  );
}

I18nInputSingle.propTypes = {
  id: PropTypes.string,
  languageOp: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  readonly: PropTypes.bool,
  allowClear: PropTypes.bool,
  inputMode: PropTypes.string,
  onClear: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
};

export default I18nInputSingle;
